import { PayloadAction } from 'typesafe-actions';
import { BeneficiariesContextActionTypes, BeneficiariesState } from './types';

// TODO: add case for loading state (separate for accountlist and accountdetails)
// TODO: add case for error state (separate for accountlist and accountdetails)
const BeneficiariesReducer = (
  state: BeneficiariesState,
  action: PayloadAction<BeneficiariesContextActionTypes, any>,
): BeneficiariesState => {
  switch (action.type) {
    case BeneficiariesContextActionTypes.GetBeneficiaries:
      return {
        ...state,
        beneficiaries: action.payload,
      };

    case BeneficiariesContextActionTypes.SetSelectedBeneficiary:
      return {
        ...state,
        selectedBeneficiary: action.payload.selectedBeneficiary,
        action: action.payload.action,
      };
    case BeneficiariesContextActionTypes.ResetSelectedBeneficiary:
      return {
        ...state,
        selectedBeneficiary: null,
        beneficiaryToDelete: null,
        action: null,
      };

    case BeneficiariesContextActionTypes.DeleteBeneficiary:
      return {
        ...state,
        beneficiaryToDelete: action.payload,
      };

    case BeneficiariesContextActionTypes.SetBeneficiariesListFilters:
      return {
        ...state,
        filters: action.payload,
      };

    default: {
      return state;
    }
  }
};

export { BeneficiariesReducer };
